import * as React from "react"

const SvgLongArrowDown = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M13 16.297V5.143a.97.97 0 0 0-.288-.713.97.97 0 0 0-.712-.287.97.97 0 0 0-.712.287.97.97 0 0 0-.287.713v11.154l-2.849-2.851a.92.92 0 0 0-.7-.288q-.4.012-.7.288-.3.3-.312.713a.93.93 0 0 0 .288.712l4.572 4.577q.15.15.325.212.175.063.375.063c.2 0 .258-.021.375-.063a.9.9 0 0 0 .325-.212l4.572-4.577q.3-.3.287-.713a1.02 1.02 0 0 0-1.012-1 .92.92 0 0 0-.7.288L13 16.296Z" />
  </svg>
)
export default SvgLongArrowDown
